import { useCallback, useState } from 'react';

import { validateTimeRangeUpdate } from './utils/general';
import { TIME_RANGE_VALIDATION_RESULTS } from '../constants/general';

import type { IParentSupervision } from '../../../../../utils/types';
import type { TimeRangeField } from '../../../../../constants';

interface UseSupervisionEventValidationParams {
  parentSupervision: IParentSupervision | null;
  values: IParentSupervision;
  onValidTimeRangeUpdate: (key: TimeRangeField, value: IParentSupervision[TimeRangeField]) => void;
}

function useSupervisionEventValidation({
  parentSupervision,
  values,
  onValidTimeRangeUpdate,
}: UseSupervisionEventValidationParams) {
  const [showRateEventWarning, setShowRateEventWarning] = useState(false);
  const [showDurationEventWarning, setShowDurationEventWarning] = useState(false);

  const handleTimeRangeUpdate = useCallback(
    (key: TimeRangeField, value: number) => {
      const result = validateTimeRangeUpdate({
        key,
        value,
        targetProgress: parentSupervision?.target_progress ?? [],
        dateStart: values?.date_start,
        expectedDuration: values?.expected_duration,
      });

      if (result === TIME_RANGE_VALIDATION_RESULTS.DURATION_OUT_OF_RANGE) {
        setShowDurationEventWarning(true);
        return;
      }

      if (result === TIME_RANGE_VALIDATION_RESULTS.RATE_OUT_OF_RANGE) {
        setShowRateEventWarning(true);
        return;
      }

      onValidTimeRangeUpdate(key, value);
    },
    [
      onValidTimeRangeUpdate,
      parentSupervision?.target_progress,
      values?.date_start,
      values?.expected_duration,
    ],
  );

  return {
    showRateEventWarning,
    setShowRateEventWarning,
    showDurationEventWarning,
    setShowDurationEventWarning,
    handleTimeRangeUpdate,
  };
}

export default useSupervisionEventValidation;
